import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { logOutAccount } from "store/user";

const ProfileLogOut = () => {

  const dispatch = useDispatch();
  const { logout } = useAuth0();

  const logOutHandle = () => {
    dispatch(logOutAccount())
    logout({
      returnTo: '/dashboard',
      federated: true,
    });
  }

  return <button className='profile-form__log-out' onClick={logOutHandle}>Log Out</button>
}

export default ProfileLogOut
